import type { ChangelogEntry } from "../types";

/**
 * VIB-2727. Bilder med dra-og-slipp og video i dokumenter. Gatet på
 * `feature_dokumentarkiv` som resten av arkivet.
 *
 * Ingen rollekrav: hvem som kan legge inn bilder styres av skrivetilgang per
 * mappe og per dokument, ikke av systemrollen.
 *
 * Punktet om video sier eksplisitt at videoen må ligge et sted fra før, og
 * hvilke steder. Det er nøyaktig det en ansatt vil lure på: «hvorfor kan jeg
 * ikke bare laste opp mp4-en?»
 */
export const BILDER_OG_VIDEO_2026_10: ChangelogEntry = {
  id: "2026-10-02-bilder-og-video",
  date: "2026-10-02",
  title: "Bilder og video i dokumenter",
  summary:
    "Dra et bilde rett inn i et dokument og slipp det der det skal stå. Video legges inn som en lenke til YouTube eller Vimeo.",
  sections: [
    {
      heading: "Dokumenter",
      items: [
        {
          title: "Dra et bilde inn i teksten",
          body: "Dra bildefila fra maskinen din og slipp den der i teksten du vil ha den. Bildet lastes opp og havner på det stedet du slapp det, midt i en setning hvis det er der du vil ha det. Store bilder krymper automatisk før de lastes opp, så et dokument med mange bilder fortsatt er raskt å åpne — du trenger ikke behandle bildet først. Grensen er 50 MB per bilde, og den er der for uhell: et telefonbilde eller et skjermbilde treffer den aldri.",
          kind: "nytt",
          featureFlag: "feature_dokumentarkiv",
        },
        {
          title: "Video legges inn som lenke, ikke som fil",
          body: "Videoen må ligge på YouTube eller Vimeo fra før. Sett markøren der videoen skal stå — står du på en tom linje, kommer verktøylinja fram av seg selv — trykk «Video», og lim inn adressen. Spilleren vises rett i dokumentet. Du kan altså ikke laste opp en videofil; arkivet er ikke et videobibliotek. Adresser fra andre steder enn YouTube og Vimeo godtas ikke, fordi en innebygd side fra et ukjent sted kan gjøre andre ting enn å spille video.",
          kind: "nytt",
          featureFlag: "feature_dokumentarkiv",
        },
        {
          title: "Bildene har samme tilgang som dokumentet",
          body: "Kan du ikke lese mappa, får du heller ikke hentet bildene i den — heller ikke med en direkte lenke. Slettes et dokument, blir bildene i det utilgjengelige med det samme, og de kommer tilbake hvis dokumentet gjenopprettes. Tar du et bilde ut av teksten og lagrer, ryddes det bort.",
          kind: "nytt",
          featureFlag: "feature_dokumentarkiv",
        },
      ],
    },
  ],
};
